'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSkipPhoneVerification = undefined;

var _deep = require('helpers/deep');

var shouldSkipPhoneVerification = exports.shouldSkipPhoneVerification = _deep.deepExtract.bind(null, 'features.phoneVerification.skipVerification');